<template lang="pug">
.report 
  WebTemplate(
    pagetitle= "转化分析",
    tip= "设置好您关注的转化目标后，转化分析报告帮助您监测各转化目标的转化数据，衡量您网站的转化效果",
    :currentTab= "currentTab",
    :total= "total",
    :pg= "pg",
    :ps= "ps",
    :tablist= "tablist",
    :customColumns= "customColumns",
    :tableDataList= "tableDataList",
    :hasCheckBox= "hasCheckBox",
    :checkboxLength= "checkboxLength",
    :sum= "sum",
    :order= "order",
    :legend= "legend", 
    :yAxis= "yAxis",
    :chartXAxis= "chartXAxis",
    :chartSeries= "chartSeries",
    tableClassname="bluethead opt-table"
    @indiceChange= "indiceChange",
    @tableUpdate= "getDataFunc",
    @tablesorter= "tablesorter",
    :customIndice= "customIndice",
    :twoIndiceShow= "twoIndiceShow",
    :twoIndice= "twoIndice")
    ul.tab(slot="tabview")
      li.tab-item(v-for="item in tabViews")
        .tabview-btn(
                @click.prevent="changeViewTo(item.comp)",
                :class="{ active: currentView === item.comp}"
              ) {{item.title}}
    div.nav-tabs(slot="nav-tabs")
      TabContent(
        title="主维度：",
        :tablist="tablist",
        :update="updateTab",
        :currentTab="currentTab")
        div.right-tab(slot="extentTab")
          DownloadBtn(
            :reportApi="reportApi",
            :params="query",
            :pagetitle="tableTabTitle",
            subtitle="",
            v-if="total > 0",
            style="float: right;")
        div(slot="common") 
          p.plan-nav(v-show="currentView !== 'system'")
            | 选择二级维度：
            v-radio-group(
              v-model="sdim",
              name="secondaryDim",
              :options="sdimOptions",
              @change.native="sdimChange")
          p.tabAction
            button.btn.btn-primary.btn-big(
              :disabled="fetchLineChartabled",
              @click="fetchLineChartData") 绘制选定行
</template>

<script>
  /* global _ */
  import Store from '../../store/store.js'
  import Mixin from '../mixin.js'
  import WebTemplate from './template'
  import { mapState, mapActions, mapGetters } from 'vuex'
  export default {
    store: Store,
    components: {
      WebTemplate
    },
    mixins: [Mixin],
    data () {
      return {
        chartResList: [],
        hasCheckBox: true,
        checkboxLength: 3,
        total: 0,
        pg: 1,
        ps: 10,
        sdim: 'null',
        sdimOptions: [],
        currentTab: 'page_trans__ttype_d__remark',
        isasc: 0,
        order: 'tnum',
        legend: [],
        yAxis: [],
        tabViews: [
          {
            comp: 'custom',
            title: '自定义转化分析',
            tablist: [
              {
                id: 'page_trans__ttype_d__remark',
                name: '页面转化',
                order: 'tnum',
                defaultIndice: ['tnum', 'trate', 'income', 'atime', 'anum'],
                reportTableApi: '/api/report/trans?groupby=trans,tid&ttype=1',
                basicSummaryStatApi: '/api/report/trans?groupby=trans,tid&issum=1&ttype=1',
                reportLineChartApi: '/api/report/trans?groupby=trans,tid&ttype=1'
              }, {
                id: 'event_trans__ttype_d__remark',
                name: '事件转化',
                order: 'tnum',
                defaultIndice: ['tnum', 'trate', 'income', 'atime', 'anum'],
                reportTableApi: '/api/report/trans?groupby=trans,tid&ttype=2',
                basicSummaryStatApi: '/api/report/trans?groupby=trans,tid&issum=1&ttype=2',
                reportLineChartApi: '/api/report/trans?groupby=trans,tid&ttype=2'
              }, {
                id: 'avg_vt_trans__ttype_d__remark',
                name: '时长转化',
                order: 'tnum',
                defaultIndice: ['tnum', 'trate', 'income', 'anum'],
                reportTableApi: '/api/report/trans?groupby=trans,tid&ttype=3',
                basicSummaryStatApi: '/api/report/trans?groupby=trans,tid&issum=1&ttype=3',
                reportLineChartApi: '/api/report/trans?groupby=trans,tid&ttype=3'
              }, {
                id: 'avg_vn_trans__ttype_d__remark',
                name: '页数转化',
                order: 'tnum',
                defaultIndice: ['tnum', 'trate', 'income', 'atime'],
                reportTableApi: '/api/report/trans?groupby=trans,tid&ttype=4',
                basicSummaryStatApi: '/api/report/trans?groupby=trans,tid&issum=1&ttype=4',
                reportLineChartApi: '/api/report/trans?groupby=trans,tid&ttype=4'
              }
            ]
          }, {
            comp: 'system',
            title: '系统转化分析',
            tablist: [
              {
                id: 'order',
                name: '订单',
                order: 'ordernum',
                defaultIndice: ['ordernum', 'orderrate', 'orderprice', 'atime', 'anum'],
                basicSummaryStatApi: '/api/report/systemTrans?groupby=trans,tid',
                reportLineChartApi: '/api/report/systemTrans?groupby=trans,tid',
                reportTableApi: '/api/report/systemTransDetail?groupby=trans,tid'
              }, {
                id: 'register',
                name: '注册',
                order: 'reg',
                defaultIndice: ['reg', 'regrate', 'atime', 'anum'],
                basicSummaryStatApi: '/api/report/systemTrans?groupby=trans,tid',
                reportLineChartApi: '/api/report/systemTrans?groupby=trans,tid',
                reportTableApi: '/api/report/systemTransDetail?groupby=trans,tid'
              }
            ]
          }
        ],
        chartXAxis: [],
        chartSeries: [],
        currentView: 'custom',
        customIndice: 'tnum',
        twoIndice: '_',
        twoIndiceShow: true,
        sum: {},
        keyword: '',
        tableDataList: []
      }
    },
    computed: {
      ...mapState('web', {
        tableIndices: state => state.tableIndices,
        compared: state => state.compared,
        compareStart: state => state.compareStart,
        compareEnd: state => state.compareEnd
      }),
      ...mapGetters('web', [
        'indicesMenu',
        'domainId',
        'uiError',
        'fetchLineChartabled',
        'twoIndiceSelectabled'
      ]),
      defaultCustomIndices () {
        return _.find(this.tablist, {id: this.currentTab}).defaultIndice
      },
      placeHolder () {
        return `请输入${_.find(this.tablist, {id: this.currentTab}).name}`
      },
      tableTabTitle () {
        return `${_.find(this.tablist, {id: this.currentTab}).name}报表`
      },
      tablist () {
        return _.find(this.tabViews, {comp: this.currentView}).tablist
      },
      customColumns () {
        const refertypeRender = (index, value, item, key) => {
          const typeDetail = ['-', '外部链接', '搜索引擎', '直接访问']
          return typeDetail[value] || '-'
        }
        const customColumns = {
          'order': [
            {
              title: '订单id',
              key: 'order_id',
              render: this.textEllipsidRender
            },
            {
              title: '订单时间',
              key: 'order_time',
              class: 'right',
              sorter: this.sorter,
              render: this.textEllipsidRender
            },
            {title: '来源类型',
              key: 'reftype',
              class: 'right',
              sorter: this.sorter,
              render: refertypeRender
            },
            {
              title: '搜索词',
              key: 'keyword',
              class: 'right',
              sorter: this.sorter,
              render: this.textEllipsidRender
            },
            {title: '订单金额',
              key: 'orderprice',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {title: '访问时长',
              key: 'atime',
              class: 'right',
              sorter: this.sorter,
              render: this.atimeRender
            },
            {title: '访问页数',
              key: 'anum',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            }
          ],
          'register': [
            {
              title: '注册id',
              key: 'order_id',
              render: this.textEllipsidRender
            },
            {
              title: '注册时间',
              key: 'order_time',
              class: 'right',
              sorter: this.sorter,
              render: this.textEllipsidRender
            },
            {title: '来源类型',
              key: 'reftype',
              class: 'right',
              sorter: this.sorter,
              render: refertypeRender
            },
            {
              title: '搜索词',
              key: 'keyword',
              class: 'right',
              sorter: this.sorter,
              render: this.textEllipsidRender
            },
            {title: '访问时长',
              key: 'atime',
              class: 'right',
              sorter: this.sorter,
              render: this.atimeRender
            },
            {title: '访问页数',
              key: 'anum',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            }
          ]
        }
        const columns = [
          {
            title: '转化目标名称',
            key: 'multiname',
            render: this.textEllipsidRender
          },
          {
            title: '转化类型细分',
            key: 'ttype_d',
            render: (index, value, item, key) => {
              const typeDetail = ['--', '订单', '注册', '咨询', '其他']
              const remark = item.ttype_d === 4 ? '-' + item.remark : ''
              if (_.has(item, 'ttype_d')) {
                return typeDetail[item.ttype_d] + remark
              } else {
                return ''
              }
            }
          }
        ]
        const systemColumns = [
          {title: '自定义转化次数',
            key: 'tnum',
            class: 'right',
            sorter: this.sorter,
            render: this.columnRender
          },
          {title: '转化率',
            key: 'trate',
            class: 'right',
            sorter: this.sorter,
            render: this.percentRender
          },
          {title: '转化价值',
            key: 'income',
            class: 'right',
            sorter: this.sorter,
            render: this.columnRender
          },
          {title: '平均访问时长',
            key: 'atime',
            class: 'right',
            sorter: this.sorter,
            render: this.atimeRender
          },
          {title: '平均访问页数',
            key: 'anum',
            class: 'right',
            sorter: this.sorter,
            render: this.columnRender
          }
        ]
        this.defaultCustomIndices.map(item => {
          const columnItem = _.find(systemColumns, {key: item})
          columns.push(columnItem)
        })
        return this.currentTab === 'order' || this.currentTab === 'register' ? customColumns[this.currentTab] : columns
      },
      query () {
        let query = {
          isasc: this.isasc,
          order: this.order,
          domainId: this.domainId,
          pvtype: 0,
          start: this.$store.state.start,
          end: this.$store.state.end,
          cycle: this.$store.state.start === this.$store.state.end ? 'hour' : 'day',
          timespan: new Date().getTime(),
          djid: this.dianjingID,
          mdim: this.currentTab
        }
        if (this.sdim !== 'null') {
          query = _.assignIn({
            sdim: this.sdim
          }, query)
        }
        if (this.compared) {
          query = _.assignIn({
            compareStart: this.compareStart,
            compareEnd: this.compareEnd
          }, query)
        }
        if (this.keyword) {
          query = _.assignIn({
            trans: this.keyword
          }, query)
        }
        return query
      },
      reportApi () {
        return _.find(this.tablist, {id: this.currentTab}).reportTableApi
      }
    },
    watch: {
      domainId () {
        this.clearKeyword()
        this.getDataFunc()
      },
      compared: function (newVal, oldVal) {
        this.compared = newVal
        this.resetIndice()
        if (newVal) {
          this.checkboxLength = 1
        } else {
          this.checkboxLength = 3
        }
      },
      uiError () {
        if (this.uiError.errMsg) {
          this.$Modal.warn(this.uiError.errMsg)
        }
      }
    },
    mounted () {
      this.setTableIndices(this.defaultCustomIndices)
    },
    methods: {
      ...mapActions('web', {
        setTableIndices: 'SET_TABLE_INDICES'
      }),
      changeViewTo (comp) {
        const view = _.find(this.tabViews, { comp })
        if (view) {
          if (this.currentView !== view.comp) {
            this.currentView = view.comp
            const currentTab = view.tablist[0].id
            this.updateTab(currentTab)
          }
        }
        this.hasCheckBox = this.currentView === 'custom'
      },
      sorter (key, order) {
        this.isasc = order
        this.order = key
        this.getDataFunc()
      },
      doSearch (keyword) {
        this.keyword = keyword
        this.getDataFunc()
      },
      updateTab: function (tab) {
        if (this.currentTab === tab) return
        this.currentTab = tab
        this.resetTab(tab)
        this.keyword = ''
        this.setTableIndices(this.defaultCustomIndices)
        this.resetIndice()
        this.getDataFunc()
      },
      getDataFunc (pn) {
        if (this.currentView === 'system') {
          if (pn) {
            this.getSystemData(pn)
          } else {
            this.getSystemSum()
            this.getSystemData(1)
          }
        } else {
          this.getTableData(pn)
        }
      },
      sdimChange () {
        this.order = _.find(this.tablist, { id: this.currentTab }).order
        this.isasc = 0
        this.getDataFunc()
      },
      getSystemSum () {
         const listParams = _.assignIn(
          {
            pg: 1,
            ps: this.ps
          },
          this.query
        )
        const api = _.find(this.tablist, {id: this.currentTab}).basicSummaryStatApi
        const tableApi = _.find(this.tablist, {id: this.currentTab}).reportTableApi
        const systemPromise = this.$http.get(api, {params: listParams})
        this.$store.dispatch('VUE_HTTP', [systemPromise])
          .then((report) => {
            const reportlist = report.list || []

            if (reportlist.length > 0) {
              this.addItemChecked(reportlist, this.compared)[0]
              const checklist = _.concat([], reportlist[0])
              this.$store.dispatch('SET_TABLE_CHECKLIST', checklist)
              this.fetchLineChartData()
            } else {
              // 清空画图数据
              this.sum = {}
              this.legend = []
              this.chartXAxis = []
              this.chartSeries = []
            }
            if (this.calcLoading) {
              this.calcLoading = false
            }
          })

      },
      getSystemData (pn) {
        this.$store.dispatch('SET_TABLE_LOADING', true)
        this.sum = {}
        this.pg = pn
        const listParams = _.assignIn(
          {
            pg: this.pg,
            ps: this.ps
          },
          this.query
        )
        const tableApi = _.find(this.tablist, {id: this.currentTab}).reportTableApi
        const tablePromise = this.$http.get(tableApi, {params: listParams})
        this.$store.dispatch('VUE_HTTP', [tablePromise])
          .then((tableList) => {
            this.total = tableList.total
            this.tableDataList = tableList.list
            
            this.$store.dispatch('SET_TABLE_LOADING', false)
            if (this.calcLoading) {
              this.calcLoading = false
            }
          })
      }
    }
  }
</script>
<style scoped>
.search {
  float: right;
}
.right-tab a {
  float: left;
}
</style>



// WEBPACK FOOTER //
// conversion.vue?4e5b7398